import React from 'react';
import './teams.css';
import TeamCard from '../teamCard/teamCard'
import Grid from '@material-ui/core/Grid';
import { getTeamMembers } from '../../services/contentService';
class Teams extends React.Component {
    constructor(props) {
      super(props);
      this.state = {projects:[],loading:true};
      // To use the 'this' keyword, we need to bind it to our function
    }
    async componentDidMount(){
        try {
            const projects = await getTeamMembers();
            this.setState({projects,loading:false});
        } catch (_) {
            this.setState({projects:[], loading:false});
        }
    }

    handleSubmit(){

    }
    
    getloading(){
        return(
               <div className = 'loader-container'>
                 <div className = 'spinner'></div>
               </div>
        );
       }


       getGrid(){
        return(
            <Grid container className='gridList' alignItems="center"
   alignContent='space-between' spacing={3}>
            {this.state.projects.map(project=>(<Grid item key={project.slug} className='team-card-grid' xs={6} sm={4} md = {3} ><TeamCard item={project}/></Grid>))}
            </Grid>
        )
       }
    render(){ 
        const response = this.state.loading?this.getloading():this.getGrid();

        return (
            <div className="team-card">
                <div className='title'>
                Team
            </div>

            <div>
            {response}
        </div>
            </div>
        )
    }

}

export default Teams;